<template>
  <div id="app">
    <router-view/>
    <lg-preview></lg-preview>
    <!--<loading></loading>-->
  </div>
</template>

<script>
  export default {
    name: 'App',
    data(){
      return {
        timeout:null
      }
    },
    created() {
      //window.document.body.removeChild(window.document.getElementById('Loading'))
     /* this.timeout=setTimeout(function(){
        let loading = window.document.getElementById('vue-loading');
        if (loading) {
          loading.style.display = 'none';
        }
      },1000)*/
    },
    beforeDestroy(){
      if(this.timeout){
        clearTimeout(this.timeout);
      }
    }
  }
</script>

<style>
  @import "assets/reset.css";
  /* html, body {
     height: 100%;
   }*/
  html{
    height: 100%;
  }
  body{

  }

  #app {
    /*min-height: 600px;*/
  }
</style>



// WEBPACK FOOTER //
// src/App.vue